export const CKB_BLAKE2B_PERSONAL = "ckb-default-hash";
